<template>
  <div class="BigBox" :style="ToSave ? {background:'rgba(0, 0, 0, 0.733)'} : {background:'#4268f6'}">
    <!-- tag内容 -->
    <van-row type="flex" justify="center" class="tag">
      <van-tag v-show="ToSave" round type="primary" color="#a3a3a2" size="large">长按图片保存</van-tag>
    </van-row>
    <!-- 图片box -->
    <van-row class="box" id="register">
      <!-- 图片 -->
      <img :src="this.noness" id="myImage" v-show="createdFlag" width="100%">
      <van-row class="codeBox" v-show="!createdFlag">
        <img src="../../../../assets/stair-Img.png">
      </van-row>
      <!-- 二维码 -->
      <van-row type="flex" justify="center" class="ewmBox" v-show="!createdFlag">
        <vue-qr :text='url' v-show="changeQR"></vue-qr>
        <van-loading type="spinner" color="#1989fa"  v-show="!changeQR"/>
      </van-row>
      <van-row id='back' v-show="!createdFlag"></van-row>
    </van-row>
    <!-- 按钮 -->
    <div class="btn">
      <van-button v-show="!hasCanvas" type="primary" @click="createdImg">生成链接</van-button>
      <van-button v-if="hasCanvas && !ToSave" type="default" @click="ToSave = true">图片保存</van-button>
      <van-button v-if="hasCanvas && !ToSave" type="primary" @click="Toteach = true">分享链接教程</van-button>
      <van-button v-if="ToSave" type="default" @click="ToSave = false">返回</van-button>
    </div>
    <van-overlay :show="Toteach" @click="Toteach = false">
      <div class="teacherShowBox">
        <div class="phone">
          <van-nav-bar title="二维码" left-arrow>
            <template #right>
              <van-icon name="weapp-nav" size="18" />
            </template>
          </van-nav-bar>
          <div class="jt"><van-icon class="ICONJT" name="down" /><span>1</span></div>
          <div class="titles">
            <p>分享链接步骤：</p>
            <p>1. 点击右上角按钮</p>
            <p>2. 选择分享对象</p>
          </div>
          <div class="jt2"><van-icon class="ICONJT" name="down" /><span>2</span></div>
          <div class="bottom">
            <div class="hearder"></div>
            <div class="content">
              <div class="first">
                <div class="anniuBox">
                  <div class="anniu"><i class="iconfont icon-fasonggeipengyou"></i></div>
                  <div class="title">发送给朋友</div>
                </div>
                <div class="anniuBox">
                  <div class="anniu"><i class="iconfont icon-fasongdaopengyouquan"></i></div>
                  <div class="title">发送至朋友圈</div>
                </div>
              </div>
            </div>
            <div class="btn">取消</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { share, initConfig } from '@/api/wxShare'
import { shareUrl } from '@/api/user.js'
import VueQr from 'vue-qr'
import wx from 'weixin-js-sdk'
import html2canvas from 'html2canvas'

export default {
  components: {
    VueQr
  },
  props: {},
  data () {
    return {
      flag: false,
      changeQR: false,
      url: '',
      ToSave: false,
      Toteach: false,
      hasCanvas: false,
      createdFlag: false,
      noness: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 生成截图内容
    async createdImg () {
      const canvas = await html2canvas(document.querySelector('#register'), {
        dpi: window.devicePixelRatio * 2, // 对应屏幕的dpi，适配高清屏，解决canvas模糊问题
        scale: 2, // 缩放
        allowTaint: true, // 是否使用图片跨域
        useCORS: true, // 是否使用图片跨域
        removeContainer: true
        // y: window.scrollY // 根据滚动条来截取--主要用于截取某一个区域
      })
      // canvas参数为生成的canvas的dom节点，可以对其进行dom操作
      // document.getElementById('register').prepend(canvas)
      this.hasCanvas = true
      this.fenxiangs()
      this.noness = canvas.toDataURL('image/png')
      this.createdFlag = true
    },
    // 调用微信分享
    fenxiangs () {
      const title = '流量管理平台'
      const desc = '点击注册'
      const imgUrl = ''
      const url = this.url
      share(title, desc, imgUrl, url).then(res => {
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取微信分享接口
    async fenxiang () {
      const urlThis = location.href.split('#')[0]
      const { data: res } = await initConfig({
        url: urlThis
      })
      if (res) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      }
    },
    // 获取二维码链接接口
    async shareUrl () {
      this.changeQR = false
      const { data: res } = await shareUrl({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      this.url = process.env.VUE_APP_DOMAIN + '/#/register?mobile=' + res.mobile
      this.$nextTick(_ => {
        this.changeQR = true
      })
    }
  },
  beforeCreate () {},
  created () {
    this.shareUrl()
    this.fenxiang()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .BigBox {
    height: 100%;
  }
  // tag样式
  .tag {
    padding:10%;
  }
  // 分享图片样式
  .box {
    margin: auto;
    width: 70vw;
    height: 60vh;
    background-color: #fff;
    box-shadow: 5px 5px 5px -2px #888888;
    border-radius: 15px;
    overflow: hidden;
    .codeBox img{
        width: 100%;
    }
    .ewmBox img{
        height: 30vh;
    }
    #back{
      position: sticky;
      background-color: #fff;
      height: 100%;
      overflow: hidden;
    }
  }
  // 按钮样式
  .btn {
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    width: 600px;
    justify-content: space-around;
  }
  // 教程样式
  .teacherShowBox {
    margin: 10vh auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000;
    width: 75vw;
    height: 80vh;
    border-radius: 30px;
    .phone {
      width: 85%;
      height: 90%;
      background-color: rgb(146, 146, 146);
      position: relative;
      .van-nav-bar {
        height: 10%;
        /deep/.van-nav-bar__content {
          height: 100%!important;
          i {
            color: #000;
            font-size: 25px!important;
          }
          .van-nav-bar__right {
            border: 1px solid red;
            border-radius: 50%;
            margin: 10px;
          }
          .van-nav-bar__title {
            font-size: 30px!important;
          }
        }
      }
      .bottom {
        position: absolute;
        bottom: 0;
        border-radius: 15px;
        background-color: #eee;
        height: 30%;
        width: 100%;
        .btn {
          position: absolute;
          bottom: 0;
          text-align: center;
          line-height: 60px;
          height: 60px;
          width: 100%;
          background-color: #fff;
          font-size: 20px;
        }
        .content {
          background-color: #eee;
          width: 100%;
          height: 60%;
          display: flex;
          align-items: center;
          padding: 0 20px;
          .first {
            display: flex;
            border: 1px solid red;
            padding: 10px 5px;
          }
          .anniuBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-left: 15px;
            .anniu {
              background-color: #fff;
              border-radius: 15px;
              height: 80px;
              width: 80px;
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                // color: rgb(145, 145, 145);
                font-size: 40px;
              }
            }
            .title {
              margin-top: 7px;
              font-size: 20px;
              color: rgb(145, 145, 145);
            }
          }
        }
        .hearder {
          height: 10%;
        }
      }
      .jt {
        position: absolute;
        top: 80px;
        right: 5px;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          border: 1px solid red;
          text-align: center;
          font-size: 60px;
          color: red;
        }
        .ICONJT {
          transform: rotateX(180deg);
          color: rgb(252, 62, 62);
          font-size: 100px;
        }
      }
      .jt2 {
        display: flex;
        position: absolute;
        right: 20px;
        bottom: 13.5%;
        z-index: 1;
        align-items: center;
        .ICONJT {
          transform-origin: 0 0;
          color: rgb(252, 62, 62);
          transform: rotate(90deg);
          font-size: 70px;
        }
        span {
          position: absolute;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          border: 1px solid red;
          text-align: center;
          font-size: 50px;
          color: red;
          left: 0;
          margin-left: 10px;
        }
      }
      .titles {
        position: absolute;
        margin: 5px;
        top: 30%;
        left: 15%;
        display: flex;
        flex-direction: column;
        p {
          font-size: 35px;
          margin: 10px 0;
          font-weight: bold;
        }
      }
    }
  }
  // 截图内容样式
  /deep/canvas {
  }
  .nones {
    display: none!important;
  }
</style>
